import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			options: [
				{
					value: "home",
					text: "Home"
				},
				{
					value: "work",
					text: "Work"
				},
				{
					value: "cell",
					text: "Cell"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
